"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _misc = require("../../misc");

var _molecules = require("../../molecules");

var _tokens = _interopRequireDefault(require("../../tokens"));

var _constants = require("./constants");

var _palette = _interopRequireDefault(require("../../themes/light-theme/palette"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var defaultMarginTop = /*#__PURE__*/(0, _styledComponents.css)(["margin-top:", ";"], function (_ref) {
  var spacing = _ref.theme.spacing;
  return spacing(2);
});
var StyledFormControl = /*#__PURE__*/(0, _styledComponents["default"])(_FormControl["default"]).withConfig({
  displayName: "CopyFromProject__StyledFormControl"
})(["", " .MuiFormControl-root{margin:", ";}&:first-child{margin-top:", ";}"], defaultMarginTop, _tokens["default"].defaultMargin, _tokens["default"].defaultMargin);
var StyledGridContainer = /*#__PURE__*/(0, _styledComponents["default"])(_Grid["default"]).withConfig({
  displayName: "CopyFromProject__StyledGridContainer"
})(["", ""], defaultMarginTop);
var CollapseSwitch = /*#__PURE__*/(0, _styledComponents["default"])(_molecules.Switch).withConfig({
  displayName: "CopyFromProject__CollapseSwitch"
})(["margin-right:", ";"], _tokens["default"].defaultMargin);
var Typography = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).withConfig({
  displayName: "CopyFromProject__Typography"
})(["color:", ";"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.grey[700];
});

var CopyFromProject = function CopyFromProject(_ref3) {
  var title = _ref3.title,
      expanded = _ref3.expanded,
      defaultClient = _ref3.defaultClient,
      clientList = _ref3.clientList,
      projectList = _ref3.projectList,
      defaultProject = _ref3.defaultProject,
      itemsToCopy = _ref3.itemsToCopy,
      itemsToCopyColumns = _ref3.itemsToCopyColumns,
      onClientChange = _ref3.onClientChange,
      onProjectChange = _ref3.onProjectChange,
      onItemsToCopyChange = _ref3.onItemsToCopyChange,
      onCollapseToggle = _ref3.onCollapseToggle,
      clientInputLabel = _ref3.clientInputLabel,
      projectInputLabel = _ref3.projectInputLabel,
      clientInputProps = _ref3.clientInputProps,
      projectInputProps = _ref3.projectInputProps;

  var _useState = (0, _react.useState)(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      projectSearchText = _useState4[0],
      setProjectSearchText = _useState4[1]; // update local state when `expanded` value changes


  (0, _react.useEffect)(function () {
    return setIsExpanded(expanded);
  }, [expanded]);
  var handleCollapseToggle = (0, _react.useCallback)(function (isExpanded) {
    setIsExpanded(isExpanded);
    onCollapseToggle(isExpanded);
  }, []);
  var renderSwitchGridItem = (0, _react.useCallback)(function (_ref4, index) {
    var label = _ref4.label,
        checked = _ref4.checked,
        key = _ref4.key;
    var gridCellWidth = 12 / itemsToCopyColumns;
    return _react["default"].createElement(_Grid["default"], {
      item: true,
      xs: gridCellWidth,
      key: "".concat(key, "-").concat(index)
    }, _react["default"].createElement(_FormControl["default"], {
      fullWidth: true
    }, _react["default"].createElement(_molecules.Switch, {
      label: label,
      checked: checked,
      key: key,
      onChange: function onChange(e) {
        return onItemsToCopyChange({
          key: key,
          checked: e.target.checked
        });
      }
    })));
  }, [onItemsToCopyChange, itemsToCopyColumns]);
  var renderSwitchRow = (0, _react.useCallback)(function (rowItems, index) {
    return _react["default"].createElement(_Grid["default"], {
      container: true,
      item: true,
      xs: 12,
      spacing: 3,
      key: "projectOptions-".concat(index)
    }, rowItems.map(renderSwitchGridItem));
  }, [renderSwitchGridItem]);
  var handleClientChange = (0, _react.useCallback)(function (e, value) {
    setProjectSearchText('');
    onClientChange(value);
  }, [onClientChange]);
  var handleProjectChange = (0, _react.useCallback)(function (e, value) {
    onProjectChange(value);
  }, [onProjectChange]);
  var handleProjectInputChange = (0, _react.useCallback)(function (e, value) {
    setProjectSearchText(value);
  }, []);
  return _react["default"].createElement(_molecules.Collapse, {
    expanded: isExpanded,
    onToggle: handleCollapseToggle,
    ToggleComponent: CollapseSwitch,
    TitleComponent: _react["default"].createElement(Typography, {
      variant: "body1"
    }, title)
  }, isExpanded && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(StyledFormControl, {
    fullWidth: true
  }, _react["default"].createElement(_molecules.ComboBox, _extends({
    fullWidth: true,
    label: clientInputLabel,
    options: clientList,
    defaultValue: defaultClient,
    onChange: handleClientChange
  }, clientInputProps))), _react["default"].createElement(StyledFormControl, {
    fullWidth: true
  }, _react["default"].createElement(_molecules.ComboBox, _extends({
    fullWidth: true,
    label: projectInputLabel,
    options: projectList,
    defaultValue: defaultProject,
    onInputChange: handleProjectInputChange,
    onChange: handleProjectChange,
    inputValue: projectSearchText
  }, projectInputProps))), itemsToCopy.length > 0 && _react["default"].createElement(StyledGridContainer, {
    container: true,
    spacing: 2
  }, (0, _misc.chunkArray)(itemsToCopy, itemsToCopyColumns).map(renderSwitchRow))));
};

CopyFromProject.propTypes = {
  title: _propTypes["default"].string,
  expanded: _propTypes["default"].bool,
  defaultClient: _propTypes["default"].shape({
    title: _propTypes["default"].string
  }),
  clientList: _propTypes["default"].array.isRequired,
  projectList: _propTypes["default"].array.isRequired,
  defaultProject: _propTypes["default"].shape({
    title: _propTypes["default"].string
  }),
  itemsToCopy: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    key: _propTypes["default"].string,
    checked: _propTypes["default"].bool
  })).isRequired,
  itemsToCopyColumns: _propTypes["default"].number,
  onClientChange: _propTypes["default"].func.isRequired,
  onProjectChange: _propTypes["default"].func.isRequired,
  onItemsToCopyChange: _propTypes["default"].func.isRequired,
  onCollapseToggle: _propTypes["default"].func,
  clientInputLabel: _propTypes["default"].string.isRequired,
  clientInputProps: _propTypes["default"].object,
  projectInputLabel: _propTypes["default"].string.isRequired,
  projectInputProps: _propTypes["default"].object
};
CopyFromProject.defaultProps = {
  itemsToCopyColumns: _constants.SWITCHES_PER_ROW,
  onCollapseToggle: function onCollapseToggle() {}
};
var _default = CopyFromProject;
exports["default"] = _default;